import useWindowSize from './useWindowSize';

const useIsMobile = (): boolean => {
  const { width } = useWindowSize();
  return width !== undefined && width <= 1024;
};

export default useIsMobile;
